export default {
  ADD_EXHIBITOR: 'Ajouter un exposant',
  NO_EXHIBITOR: "Vous n’avez pas encore ajouté d'exposant!",
  EXHIBITOR_NAME: 'Nom de l’exposant',
  EXHIBITOR_EMAIL: 'E-mail de l’exposant',
  EXHIBITOR_CONTACT: 'Contact de l’exposant',
  CITY: 'Ville',
  COUNTRY: 'Pays',
  ADDRESS: 'Adresse',
  ORGANISATION: 'Organisation',
  TRANSACTION_ID: 'Identité de la transaction',
  DATE_OF_PURCHASE: 'Date d’achat',
  DEVICES_COUNT: 'Nombre d’appareils',
  ADD_EXHIBITOR_SUCCESS: 'Votre profil d’exposant a été configuré avec succès!',
  LICENSE_DETAILS: 'Détails de la licence',
  UPDATE_EXHIBITOR_SUCCESS: 'Votre profil d’exposant a été mis à jour avec succès!',
  EDIT_EXHIBITOR: 'Modifier l’exposant'
}
